import { render } from "./signup.vue?vue&type=template&id=3ad58f56&scoped=true"
import script from "./signup.vue?vue&type=script&lang=js"
export * from "./signup.vue?vue&type=script&lang=js"

import "./signup.vue?vue&type=style&index=0&id=3ad58f56&scoped=true&lang=css"

import exportComponent from "/appwd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ad58f56"]])

export default __exports__